import { FileItemsResponse, FolderId, FolderResponse, FileResponse, FileId } from '@business/entities/file';
import { OrgId } from '@business/entities/organization';
import { Endpoint } from '../endpoint';
import { TenantIdentity } from '@business/entities/common';
import { FormId } from '@business/entities/form';

export function getItems(orgId: OrgId, parentId?: FolderId, isPublic = false, identity?: TenantIdentity) {
  return Endpoint.get<FileItemsResponse>(`@gc/shared-folder`, { params: { orgId, parentId, isPublic }, identity });
}

export function createFolder(orgId: OrgId, name: string, parentId?: FolderId, isPublic = false, identity?: TenantIdentity) {
  return Endpoint.post<FolderResponse>(`@gc/shared-folder`, { identity, data: { orgId, name, parentId, isPublic } });
}

export function renameFolder(id: FolderId, name: string, identity?: TenantIdentity) {
  return Endpoint.patch<FolderResponse>(`@gc/shared-folder/${id}`, { identity, data: { name } });
}

export function deleteFolder(id: FolderId, identity?: TenantIdentity) {
  return Endpoint.delete<void>(`@gc/shared-folder/${id}`, { identity });
}

export function search(orgId: OrgId, search: string, parentId?: FolderId, identity?: TenantIdentity) {
  return Endpoint.get<FileItemsResponse>(`@gc/shared-folder/search`, { params: { orgId, search, parentId }, identity });
}

export function createDocument(orgId: OrgId, name: string, folderId: FolderId, identity?: TenantIdentity) {
  return Endpoint.post<FileResponse>(`@gc/shared-folder/document`, { identity, data: { orgId, name, folderId } });
}

export function createForm(orgId: OrgId, name: string, folderId: FolderId, form: FormId, identity?: TenantIdentity) {
  return Endpoint.post<FileResponse>(`@gc/shared-folder/form`, { identity, data: { orgId, name, folderId, form } });
}

export function saveFormValues(id: string, values: string, identity?: TenantIdentity) {
  return Endpoint.post<FileResponse>(`@gc/shared-folder/save-values/${id}`, { identity, data: { values } });
}
/* Files */
export function renameFile(id: FileId, name: string, identity?: TenantIdentity) {
  return Endpoint.patch<FileResponse>(`@gc/shared-folder/file/${id}`, { identity, data: { name } });
}

export function deleteFile(id: FileId, identity?: TenantIdentity) {
  return Endpoint.delete<void>(`@gc/shared-folder/file/${id}`, { identity });
}

export function reloadFile(id: string, identity?: TenantIdentity) {
  return Endpoint.get<FileResponse>(`@gc/shared-folder/reload-file/${id}`, { identity });
}
